module.exports = __webpack_public_path__ + "img/img31.09c93f88.png";